import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Button from "./ui/Button";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { RoleGate } from "./middleware/RoleGate.jsx";


const mesesDelAnio = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const getTipo = (tiposSocio, id) => {
  if (!Array.isArray(tiposSocio)) return "Desconocido";
  const tipo = tiposSocio.find(t => Number(t.id) === Number(id));
  return tipo ? tipo.nombre : "Desconocido";
};

const Contabilidad = () => {
  const [socios, setSocios] = useState([]);
  const [tiposSocio, setTiposSocio] = useState([]);
  const [pagos, setPagos] = useState({});
  const [selectedSocio, setSelectedSocio] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalMontos, setShowModalMontos] = useState(false);
  const [showModalCI, setShowModalCI] = useState(false);
  const [montosPorTipo, setMontosPorTipo] = useState({});
  const [montosEspeciales, setMontosEspeciales] = useState({});
  const [busqueda, setBusqueda] = useState("");
  const [tipoFiltro, setTipoFiltro] = useState("todos");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [Internacional, setInternacional] = useState(false);

  useEffect(() => {
    fetchTiposSocio();
    fetchMontos();
  }, []);

  useEffect(() => {
    if (tiposSocio.length > 0) {
      fetchSocios();
    }
  }, [tiposSocio]);

  const fetchSocios = async () => {
    try {
      const [sociosRes, pagosRes] = await Promise.all([
        axios.get("http://192.168.1.81:5000/backend/api/socios"),
        axios.get("http://192.168.1.81:5000/backend/api/pagos")
      ]);

      const sociosConPagos = sociosRes.data.map((socio) => ({
        ...socio,
        tipo: getTipo(tiposSocio, socio.tipo_socio),
        pagos: pagosRes.data[socio.rut] || {}
      }));

      setSocios(sociosConPagos);
    } catch (error) {
      console.error("Error al obtener socios o pagos", error);
    }
  };

  const fetchMontos = async () => {
    try {
      const res = await axios.get("http://192.168.1.81:5000/backend/api/montos");
      const mapa = {};
      res.data.forEach((item) => {
        mapa[item.id] = item.monto;
      });
      setMontosPorTipo(mapa);
      console.log("Montos por tipo obtenidos:", mapa);
    } catch (err) {
      console.error("Error al obtener montos por tipo:", err);
    }
  };

  const fetchMontosEspeciales = async () => {
    try {
      const res = await axios.get("http://192.168.1.81:5000/backend/api/montos_esp");
      const mapa = {};
      res.data.forEach((item) => {
        mapa[item.id] = item.monto;
      });
      setMontosEspeciales(mapa);
      console.log("Montos especiales obtenidos:", mapa);
    } catch (err) {
      console.error("Error al obtener montos especiales:", err);
    }
  };


  const fetchTiposSocio = async () => {
    try {
      const { data } = await axios.get("http://192.168.1.81:5000/backend/api/tipos");
      setTiposSocio(data);
    } catch (error) {
      console.error("Error al obtener tipos de socio:", error);
    }
  };

  const getUltimoMesPagado = (pagos) => {
    if (!pagos || typeof pagos !== "object") return "N/A";
    const mesesPagados = Object.keys(pagos).filter(mes => pagos[mes]?.pagado);
    return mesesPagados.length ? mesesPagados[mesesPagados.length - 1] : "N/A";
  };

  const handleEdit = async (socio) => {
    try {
      const { data: pagosDelSocio } = await axios.get(`http://192.168.1.81:5000/backend/api/pagos/${socio.rut}`);
      const añoActual = new Date().getFullYear();

      const pagosActualizados = mesesDelAnio.reduce((acc, mes) => {
        const pago = pagosDelSocio["pagos"].find(p => p.mes.toLowerCase() === mes.toLowerCase() && p.año === añoActual);
        const clave = `${mes} ${añoActual}`;
        acc[clave] = pago ? Boolean(pago.pagado) : false;
        return acc;
      }, {});

      setSelectedSocio(socio);
      setPagos(pagosActualizados);
      setShowModal(true);
    } catch (error) {
      console.error("Error al obtener pagos del socio", error);
    }
  };

  const handlePagoChange = (mes) => {
    setPagos(prev => ({
      ...prev,
      [mes]: !prev[mes]
    }));
  };

  const handleSave = async () => {
    try {
      const tipoId = selectedSocio.tipo_socio;
      const montoPorDefecto = montosPorTipo[tipoId] || 0;

      const pagosConMonto = Object.keys(pagos).reduce((acc, mes) => {
        acc[mes] = { pagado: pagos[mes], monto: pagos[mes] ? montoPorDefecto : 0 };
        return acc;
      }, {});

      await axios.put(`http://192.168.1.81:5000/backend/api/pagos/${selectedSocio.rut}`, { pagos: pagosConMonto });
      fetchSocios();
      setShowModal(false);
    } catch (error) {
      console.error("Error al actualizar pagos", error);
    }
  };

  const guardarMontos = async () => {
    try {
      await axios.put("http://192.168.1.81:5000/backend/api/montos", montosPorTipo);
      await axios.put("http://192.168.1.81:5000/backend/api/montos_esp", montosEspeciales);
      console.log("Montos por tipo guardados:", montosPorTipo);
      console.log("Montos especiales guardados:", montosEspeciales);
      alert("Montos guardados correctamente.");
      setShowModalMontos(false);
    } catch (error) {
      console.error("Error al guardar montos por tipo:", error);
      alert("Hubo un error al guardar los montos.");
    }
  };

  const exportarExcel = () => {
    const datos = sociosFiltrados.map(s => ({
      "N° Socio": s.n_socio,
      "RUT": s.rut,
      "Nombre": `${s.nombre} ${s.apellido}`,
      "Tipo": s.tipo,
      "Último Mes Pagado": getUltimoMesPagado(s.pagos)
    }));
    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Socios");
    XLSX.writeFile(wb, "socios-contabilidad.xlsx");
  };

  const exportarPDF = () => {
    const doc = new jsPDF();

    const columns = ["N° Socio", "RUT", "Nombre", "Tipo", "Último Mes Pagado"];

    const data = sociosFiltrados.map(socio => [
      socio.n_socio,
      socio.rut,
      `${socio.nombre} ${socio.apellido}`,
      socio.tipo,
      getUltimoMesPagado(socio.pagos)
    ]);

    const options = {
      startY: 20,
      headStyles: { fillColor: [41, 128, 185] },
      styles: { overflow: 'linebreak' },
      columnStyles: { 0: { halign: 'center' } }
    };

    autoTable(doc, {
      head: [columns],
      body: data,
      ...options
    });
    doc.save("socios-contabilidad.pdf");
  };

  const sociosFiltrados = socios.filter(s => {
    const coincideBusqueda = `${s.nombre} ${s.apellido} ${s.rut} ${s.n_socio}`.toLowerCase().includes(busqueda.toLowerCase());
    const coincideTipo = tipoFiltro === "todos" || String(s.tipo) === tipoFiltro;
    return coincideBusqueda && coincideTipo;
  });

  const totalPages = Math.ceil(sociosFiltrados.length / rowsPerPage);
  const sociosPaginados = sociosFiltrados.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);


  const getVisiblePageNumbers = () => {
    const totalPages = Math.ceil(sociosFiltrados.length / rowsPerPage);
    const visiblePages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - maxVisiblePages + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }

    return visiblePages;
  };
  const indexOfLastSocio = currentPage * rowsPerPage;
  const indexOfFirstSocio = indexOfLastSocio - rowsPerPage;
  const totalSocios = sociosFiltrados;



  return (
    <div className="container mt-5">
      <Card className="shadow p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="mb-0">Contabilidad de Socios</h2>
          <div className="d-flex gap-2">
            <RoleGate allowedRoles={["Administrador", "Contador"]}>
              <Button
                className="btn btn-info"
                onClick={async () => {
                  await fetchMontos();
                  await fetchMontosEspeciales();
                  setShowModalMontos(true);
                }}
              >
                Monto Cuotas
              </Button>

              <Button className="btn btn-info" onClick={showModalCI}>
                Ingresar Cuota de Incorporación
              </Button>

              <Link style={{ color: "white", height: "100%" }} to="/reportes" className="btn btn-warning">Reportes</Link>
            </RoleGate>
          </div>
        </div>

        <div className="d-flex justify-content-between mb-4 align-items-end gap-2">
          <TextField label="BUSCAR POR N° SOCIO, RUT O NOMBRE" fullWidth value={busqueda} onChange={e => setBusqueda(e.target.value)} size="small" />
          <select className="form-control" value={tipoFiltro} onChange={e => setTipoFiltro(e.target.value)}>
            <option value="todos">Todos los tipos</option>
            {tiposSocio.map(t => (
              <option key={t.id} value={t.nombre}>{t.nombre}</option>
            ))}
          </select>
          <Button title="Exportar a Excel" className="btn btn-success btn-sm" onClick={exportarExcel}><FontAwesomeIcon icon={faFileExcel} size="xl" /></Button>
          <Button title="Exportar a PDF" className="btn btn-danger btn-sm" onClick={exportarPDF}><FontAwesomeIcon icon={faFilePdf} size="xl" /></Button>
        </div>
        <div className="mb-4">
          <label className="mr-2 font-medium">N° de filas: </label>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
            className="border rounded px-2 py-1"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        <div className="table-responsive" id="tabla-socios">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>N° Socio</th>
                <th>RUT</th>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Último mes pagado</th>
                <RoleGate allowedRoles={["Administrador", "Contador"]}>
                  <th>Acciones</th>
                </RoleGate>
              </tr>
            </thead>
            <tbody>
              {sociosPaginados.map(socio => {
                const ultimoMes = getUltimoMesPagado(socio.pagos);
                const esMoroso = ultimoMes === "N/A" || !ultimoMes.includes(new Date().getFullYear());
                return (
                  <tr key={socio.rut} className={esMoroso ? "table-danger" : ""}>
                    <td>{socio.n_socio}</td>
                    <td>{socio.rut}</td>
                    <td>{socio.nombre} {socio.apellido}</td>
                    <td className={`badge bg-${String(socio.tipo_socio) === "1" ? "success" : String(socio.tipo_socio) === "2" ? "secondary" : String(socio.tipo_socio) === "3" ? "info" : "warning"}`} style={{ display: "inline-block", color: "white", padding: "5px" }}>
                      {String(socio.tipo_socio) === "1" ? "ACTIVO" : String(socio.tipo_socio) === "2" ? "PASIVO" : String(socio.tipo_socio) === "3" ? "COOPERADOR" : "ESTUDIANTE"}
                    </td>
                    <td>{ultimoMes.toUpperCase()}</td>
                    <RoleGate allowedRoles={["Administrador", "Contador"]}>
                      <td><button className="btn btn-sm me-2" title="Editar" onClick={() => handleEdit(socio)}><FontAwesomeIcon icon={faPenToSquare} /></button></td>
                    </RoleGate>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <p className="text-center text-muted">
          Mostrando {indexOfFirstSocio + 1}–{Math.min(indexOfLastSocio, totalSocios.length)} de {totalSocios.length} Socios Kolping
        </p>
        <div className="d-flex justify-content-right mt-3">
          <nav>
            <div className="d-flex justify-content-right mt-3">
              <nav>
                <ul className="pagination">

                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                      Anterior
                    </button>
                  </li>

                  {getVisiblePageNumbers().map((number) => (
                    <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                      <button className="page-link" onClick={() => setCurrentPage(number)}>
                        {number}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                      Siguiente
                    </button>
                  </li>

                </ul>
              </nav>
            </div>

          </nav>
        </div>
      </Card>

      {/* Modal de pagos */}
      {selectedSocio && showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered" style={{ width: "300px" }}>
            <div className="modal-content" >
              <div className="modal-header">
                <h5 className="modal-title">Editar Pagos - {selectedSocio.nombre} {selectedSocio.apellido}</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                {mesesDelAnio.map((mes) => {
                  const clave = `${mes} ${new Date().getFullYear()}`;
                  return (
                    <div key={clave} className="d-flex justify-content-between align-items-center mb-2">
                      <label >{clave}</label>
                      <Switch
                        checked={!!pagos[clave]}
                        onChange={() => handlePagoChange(clave)}
                        color="primary"
                      />
                    </div>
                  );
                })}

                <div className="d-flex justify-content-between align-items-center mb-2-3 mt-4">
                  <label>Internacional</label>
                  <Switch
                    checked={Internacional}
                    onChange={() => setInternacional(!Internacional)}
                    color="primary"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <Button className="btn btn-success" onClick={handleSave}>Guardar</Button>
                <Button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal de montos por tipo de socio */}
      {showModalMontos && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Monto de Cuotas</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModalMontos(false)}
                ></button>
              </div>

              <div className="modal-body">
                {/* 🔹 Cuota de Incorporación */}
                <div className="mb-3">
                  <label className="form-label">CUOTA DE INCORPORACIÓN</label>
                  <TextField
                    type="number"
                    value={montosEspeciales[5] ?? "0"}
                    onChange={(e) =>
                      setMontosEspeciales((prev) => ({
                        ...prev,
                        [5]: Number(e.target.value),
                      }))
                    }
                    fullWidth
                    slotProps={{
                      htmlInput: {
                        step: 100,
                        min: 0,
                      },
                    }}
                  />
                </div>

                {/* 🔹 Cuota Internacional */}
                <div className="mb-3">
                  <label className="form-label">CUOTA INTERNACIONAL</label>
                  <TextField
                    type="number"
                    value={montosEspeciales[6] ?? "1"}
                    onChange={(e) =>
                      setMontosEspeciales((prev) => ({
                        ...prev,
                        [6]: Number(e.target.value),
                      }))
                    }
                    fullWidth
                    slotProps={{
                      htmlInput: {
                        step: 100,
                        min: 0,
                      },
                    }}
                  />
                </div>
                <hr />
                Cuota Mensual por Tipo de Socio:
                <hr />

                {/* 🔹 Cuotas por tipo de socio */}
                {tiposSocio.map((tipo) => (
                  <div key={tipo.id} className="mb-3">
                    <label className="form-label">{tipo.nombre}</label>
                    <TextField
                      type="number"
                      value={montosPorTipo[tipo.id] ?? "0"}
                      onChange={(e) =>
                        setMontosPorTipo((prev) => ({
                          ...prev,
                          [tipo.id]: Number(e.target.value),
                        }))
                      }
                      fullWidth
                      slotProps={{
                        htmlInput: {
                          step: 100,
                          min: 0,
                        },
                      }}
                    />
                  </div>
                ))}
              </div>

              <div className="modal-footer">
                <Button className="btn btn-success" onClick={guardarMontos}>
                  Guardar
                </Button>
                <Button
                  className="btn btn-secondary"
                  onClick={() => setShowModalMontos(false)}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default Contabilidad;
